import styled, { css } from 'styled-components';

export const OrderItemContainer = styled.div`
  background-color: #fff;
  border-bottom: 1px solid #e0e0e0;
  padding: 21px 15px 10px 15px;
`;

const textPlaceHolder = css`
  @keyframes textPlaceHolder {
    0% {
      background-position: -350px 0;
    }
    100% {
      background-position: 350px 0;
    }
  }
`;
export const BackgroundAnimation = styled.span`
  ${textPlaceHolder}
  display: inline-block;
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: textPlaceHolder;
  animation-timing-function: linear;
  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
  background-size: 800px 104px;
  height: 96px;
  position: relative;
`;

export const DescribeBackgroundAnimation = styled.span`
  display: inline-block;
`;

export const OrderItemContent = styled.div`
  margin-bottom: 16px;
  width: 100%;
  ${BackgroundAnimation} {
    width: 40px;
    height: 20px;
    margin-right: 10px;
  }
  ${DescribeBackgroundAnimation} {
    width: 62px;
    height: 15px;
    margin-right: 10px;
  }
`;

export const OrderItemClient = styled.div`
  margin-bottom: 6px;
  width: 100%;
  ${BackgroundAnimation} {
    width: 150px;
    height: 20px;
    margin-right: 10px;
  }
  ${DescribeBackgroundAnimation} {
    width: 62px;
    height: 20px;
    margin-right: 10px;
  }
`;

export const OrderItemArea = styled.div`
  height: 25px;
  width: 100%;
  margin-top: 10px;
  ${BackgroundAnimation} {
    width: 200px;
    height: 15px;
    margin-right: 10px;
  }
  ${DescribeBackgroundAnimation} {
    width: 62px;
    height: 15px;
    margin-right: 10px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/OrderItemPlaceholder/style.js